import 'core-js/es'
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app';
import AppRoute from './index1'
import { ConfigProvider } from 'antd';
// import zhCN from 'antd/es/locale/zh_CN';
import zh_CN from 'antd/lib/locale-provider/zh_CN'
import * as serviceWorker from './serviceWorker';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { HashRouter } from 'react-router-dom';
moment.locale('zh-cn');

ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider locale={zh_CN}>
      <HashRouter>
        <AppRoute />
      </HashRouter>
      {/* <App /> */}
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
